import { enumify } from '../utils/enumify'

export const HORIZONTAL_DIVIDER_HEIGHTS = enumify(['small', 'default', 'tall'])
